import React from "react";
import CvDetail from "./CvDetail";
import CvGroup from "./CvGroup";

const IdReference = ({data, cvs}) => {

    const cvobj = cvs?.['ct:cv']?.find(cvit => cvit?.id === data?.id)
    if( cvobj) {
        return <CvDetail key={cvobj?.id} data={cvobj} activeItems={data?.activeItems}/>
    }

    const cvgroup = cvs?.['ct:cvGroup']?.find(cvit => cvit?.id === data?.id)
    if (cvgroup) {
        return <CvGroup key={cvgroup?.id} data={cvgroup} activeItems={data?.attributes?.activeItems} />
    }

    return null
}

export default IdReference;
